:root ._dsp-flex{display:flex;}
:root ._items-stretch{align-items:stretch;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._pos-relative{position:relative;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._fd-row{flex-direction:row;}
:root ._fd-column{flex-direction:column;}
:root ._cur-pointer{cursor:pointer;}
:root ._btw-1px{border-top-width:1px;}
:root ._brw-0px{border-right-width:0px;}
:root ._borderBottomWidth-1px{border-bottom-width:1px;}
:root ._borderLeftWidth-1px{border-left-width:1px;}
:root ._btc-divider{border-top-color:var(--divider);}
:root ._brc-divider{border-right-color:var(--divider);}
:root ._borderBottomColor-divider{border-bottom-color:var(--divider);}
:root ._borderLeftColor-divider{border-left-color:var(--divider);}
:root ._bg-background{background-color:var(--background);}
:root ._items-center{align-items:center;}
:root ._pt-t-space-med104641{padding-top:var(--t-space-medium);}
:root ._pr-t-space-med104641{padding-right:var(--t-space-medium);}
:root ._pb-t-space-med104641{padding-bottom:var(--t-space-medium);}
:root ._pl-t-space-med104641{padding-left:var(--t-space-medium);}
:root ._borderBottomStyle-solid{border-bottom-style:solid;}
:root ._borderTopStyle-solid{border-top-style:solid;}
:root ._borderLeftStyle-solid{border-left-style:solid;}
:root ._borderRightStyle-solid{border-right-style:solid;}
:root ._gap-t-space-lar102228{gap:var(--t-space-larger);}
:root ._justify-space-betwe3241{justify-content:space-between;}
:root ._width-10037{width:100%;}
:root ._mb-t-space-med104641{margin-bottom:var(--t-space-medium);}
:root ._gap-t-space-med104641{gap:var(--t-space-medium);}
:root ._gap-t-space-sma3456{gap:var(--t-space-small);}
:root ._pos-absolute{position:absolute;}
:root ._r-0px{right:0px;}
:root ._t-0px{top:0px;}
:root ._b-0px{bottom:0px;}
:root ._btc-primary{border-top-color:var(--primary);}
:root ._brc-primary{border-right-color:var(--primary);}
:root ._borderBottomColor-primary{border-bottom-color:var(--primary);}
:root ._borderLeftColor-primary{border-left-color:var(--primary);}
:root ._borderLeftWidth-4px{border-left-width:4px;}
:root ._btlr-10px{border-top-left-radius:10px;}
:root ._btrr-10px{border-top-right-radius:10px;}
:root ._bbrr-10px{border-bottom-right-radius:10px;}
:root ._bblr-10px{border-bottom-left-radius:10px;}